import request from "../utils/request";
import anrequest from "../utils/anrequest";
import partrequest from "../utils/partrequest";
// 场地详情
export function placeGet (data, headers) {
  return request({
    url: "/api-o/v1/overland/place/get/" + data.id,
    method: "GET",
    headers,
  });
}
//活动详情
export function actGetAct (data, headers) {
  return request({
    url: "/api-o/v1/overland/act/getAct/" + data.id,
    method: "GET",
    data,
    headers,
  });
}
//查询想去信息  /v1/community/bbsLike/selectLikedByTemId
export function selectLikeByTemId (data, headers) {
  return request({
    url: "/api-c/v1/community/bbsLike/selectLikedByTemId",
    method: "POST",
    data,
    headers,
  });
}
//报名
export function insertActUser (data, headers) {
  return anrequest({
    url: "/api-o/v1/overland/act/insertActUser",
    method: "POST",
    data,
    headers,
  });
}
//动态帖子
export function queryDynamicById (params, headers) {
  return request({
    url: "/api-c/v1/community/dynamic/queryDynamicById",
    method: "GET",
    params,
    headers,
  });
}

// 查询资讯专题
export function getInformation (data, headers) {
  return request({
    url: "/api-c/v1/community/information/getInformationById/" + data.id,
    method: "GET",
    headers,
  });
}


//行政区划
export function citylistType (data, headers) {
  return request({
    url: "/api-m/v1/system/region/listAll",
    method: "POST",
    data,
    headers,
  });
}
//根据UserId查询用户信息
export function getByUserId (data, headers) {
  return request({
    url: "/api-u/v1/user/info/getByUserId/" + data.id,
    method: "GET",
    headers,
  });
}
//查询所有车型
export function baseListType (data, headers) {
  return request({
    url: "/api-m/v1/mycar/base/listType",
    method: "POST",
    data,
    headers,
  });
}
//经销商列表
export function dealerListAll (data, headers) {
  return request({
    url: "/api-m/v1/mycar/dealer/listAll",
    method: "POST",
    data,
    headers,
  });
}
//城市
export function regionListAll (data, headers) {
  return request({
    url: "/api-s/v1/system/region/listAll",
    method: "POST",
    data,
    headers,
  });
}
//新增皮卡预约
export function createPickup (data, headers) {
  return anrequest({
    url: "/api-m/v1/mycar/subscribe/createPickup",
    method: "POST",
    data,
    headers,
  });
}
//邀请试驾短信验证码发送  /v1/msg/sms/sendSms
export function smsSend (data, headers) {
  return request({
    url: "/api-msg/v1/msg/sms/push",
    method: "POST",
    data,
    headers,
  });
}
//短信验证码验证
export function smsValid (data, headers) {
  return anrequest({
    url: "/api-msg/v1/msg/sms/validCode",
    method: "POST",
    data,
    headers,
  });
}
//邀请注册短信验证码 
export function authGetSMSCode (data, headers) {
  return anrequest({
    url: "/api-u/v1/pickup/user/auth/getSMSCode",
    method: "POST",
    data,
    headers,
  });
}
//邀请注册  
export function authLoginForCode (data, headers) {
  return anrequest({
    url: "/api-u/v1/pickup/user/auth/loginForCode",
    method: "POST",
    data,
    headers,
  });
}
//邀请注册,通过阿里风险识别
export function authLoginForCodeAliyun (data, headers) {
  return anrequest({
    url: "/api-u/v1/pickup/user/auth/register",
    method: "POST",
    data,
    headers,
  });
}
//皮卡校园瀑布流 test
export function queryCampusList (data, headers) {
  return request({
    url: "/api-c/v1/community/appCampus/queryCampusList",
    method: "POST",
    data,
    headers,
  });
}
//路线详情
export function roadbookGetDetail (data, headers) {
  return request({
    url: "/api-o/v1/overland/roadbook/getDetail/" + data.bookId,
    method: "GET",
    headers,
  });
}
//资讯明细  /v1/community/information/getInformationById/{informationId}
export function getInformationById (data, headers) {
  return request({
    url: "/api-c/v1/community/information/getInformationById/" + data.id,
    method: "GET",
    headers,
  });
}
//话题详情
export function queryTopicById (data, headers) {
  return request({
    url: "/api-c/v1/community/topic/queryTopicById/" + data.id,
    method: "GET",
    headers,
  });
}
//话题详情下的帖子列表
export function queryPostsDynomicAllByTopicDTO (data, headers) {
  return request({
    url: "/api-c/v1/community/topic/queryPostsDynomicAllByTopicDTO",
    method: "POST",
    data,
    headers,
  });
}
//话题详情下的热门帖子列表
export function queryPostsDynomicHotByTopicDTO (data, headers) {
  return request({
    url: "/api-c/v1/community/topic/queryPostsDynomicHotByTopicDTO",
    method: "POST",
    data,
    headers,
  });
}
//帖子详情 /v1/community/posts/qryDetails
export function postsQryDetails (data, headers) {
  return request({
    url: "/api-c/v1/community/posts/qryDetails",
    method: "POST",
    data,
    headers,
  });
}
//我的权益 /v1/app/rights/record
export function rightsRecord (params, headers) {
  return request({
    url: "/api-u/v1/app/rights/record",
    method: "GET",
    params,
    headers,
  });
}
//权益类型列表 /v1/app/rights/type/list
// export function rightsList (params, headers) {
//   return request({
//     url: "/api-u/v1/app/rights/list",
//     method: "GET",
//     params,
//     headers,
//   });
// }

//权益类型列表 /v2/app/rights/type/list
export function rightsList (params, headers) {
  return request({
    url: "/api-u/v2/app/rights/type/list",
    method: "GET",
    params,
    headers,
  });
}

export function getUserRightsAppList (data, headers) {
  return request({
    url: "/api-u/v2/app/rights/getUserRightsAppList",
    method: "POST",
    data,
    headers,
  });
}
//售后券 /v1/user/coupon/userCouponList
export function userCouponList (data, headers) {
  return request({
    url: "/api-u/v1/user/coupon/userCouponList",
    method: "POST",
    data,
    headers,
  });
}
//权益详情
export function rightsDetail (params, headers) {
  return request({
    url: "/api-u/v1/app/rights/" + params.id,
    method: "GET",
    params: params.drawObj,
    headers,
  });
}
//领取权益 /v1/app/rights/draw/{id}
export function rightsDraw (data, headers) {
  return anrequest({
    url: "/api-u/v1/app/rights/draw/" + data.id,
    method: "POST",
    headers,
  });
}
//车友会详情 /v1/community/mactalk/basic/viewSample/{basicId}
export function viewSample (data, headers) {
  return request({
    url: "/api-c/v1/community/mactalk/basic/viewSample/" + data.basicId,
    method: "GET",
    headers,
  });
}
//车友会成员  /v1/community/mactalk/member/listAll
export function memberList (data, headers) {
  return request({
    url: "/api-c/v1/community/mactalk/member/list",
    method: "POST",
    data,
    headers,
  });
}
//车友会成员
export function getPosterByCarType (data, headers) {
  return request({
    url: "/api-u/sysPoster/getPosterByCarType",
    method: "POST",
    data,
    headers,
  });
}
//场地动态详情 /v1/overland/dynamic/viewById/{id}
export function dynamicView (data, headers) {
  return request({
    url: "/api-o/v1/overland/dynamic/viewById/" + data.id,
    method: "GET",
    headers,
  });
}
//打卡动态详情 /v1/overland/overlandAct/getVideoDetail/{id}
export function clockDynamicView(data, headers) {
  return request({
    url: "/api-o/v1/overland/overlandAct/getVideoDetail/" + data.id,
    method: "GET",
    headers,
  });
}
//获取视屏
export function getVideo (data, headers) {
  return request({
    url: "/api-o/v1/video/getVideoUrl",
    method: "POST",
    data,
    headers,
  });
}
//获取安卓最新下载地址
export function getUrl (data, headers) {
  return request({
    url: "/api-s/v1/system/appVersion/selectNewVersionInfo",
    method: "GET",
    data,
    headers,
  });
}
//登录
export function pklogin (data, headers) {
  return request({
    url: "/api-u/v1/pickup/user/auth/loginForPwd",
    method: "POST",
    data,
    headers,
  });
}
// 邀请注册规则
export function queryInviteConf (data, headers) {
  return request({
    url: "/api-c/v1/community/invite/config/queryActiveConf",
    method: "GET",
    data,
    headers
  })
}
//邀请记录
export function findPage (data, headers) {
  return request({
    url: "/api-u/v1/user/regRecord/findPage",
    method: "POST",
    data,
    headers,
  });
}
//售后券详情 /v1/app/rights/getDetailBySn/{sn}
export function getDetailBySn (data, headers) {
  return anrequest({
    url: "/api-u/v1/app/rights/getDetailBySn/" + data.id,
    method: "GET",
    data,
    headers,
  });
}
//合伙人
export function listTree (data, headers) {
  return request({
    url: "/api-s/v1/system/region/listTree",
    method: "POST",
    data,
    headers,
  });
}
//根据手机号查询用户身份标签
export function checkUserIsCarOwner (data, headers) {
  return request({
    url: "/api-o/v1/broker/userLabel/" + data.mobile,
    method: "GET",
    data,
    headers,
  });
}

//活动列表
export function listGetApp (data, headers) {
  return request({
    url: "/api-o/v1/broker/introduceList",
    method: "POST",
    data,
    headers,
  });
}
//活动详情
export function infoGet (data, headers) {
  return request({
    url: "/api-o/v1/broker/introduceInfo/" + data.introduceId,
    method: "GET",
    data,
    headers,
  });
}


//根据手机号查用户
export function findUserByTel (data, headers) {
  return request({
    url: "/api-u/v1/user/info/getUserInfoByPhone/" + data.phone,
    method: "GET",
    data,
    headers,
  });
}
//获取用户身份标志
export function firstByMobile (params, headers) {
  return partrequest({
    url: "/base/user/label/firstByMobile",
    method: "GET",
    params,
    headers,
  });
}
//合伙人发送验证码
export function verificationCode (data, headers) {
  return anrequest({
    url: "/api-u/v1/user/auth/verificationCode",
    method: "POST",
    data,
    headers,
  });
}
//合伙人校验验证码
export function authCodeValidate (data, headers) {
  return anrequest({
    url: "/api-u/v1/user/auth/authCodeValidate",
    method: "POST",
    data,
    headers,
  });
}
//获取有经销商的省份城市列表
export function getHasDealerProvinceCitys (params, headers) {
  return request({
    url: "/api-o/v1/broker/getHasDealerProvinceCitys",
    method: "GET",
    params,
    headers,
  });
}
//根据城市获取经销商列表
export function getDealerListByCity (params, headers) {
  return request({
    url: "/api-o/v1/broker/getDealerListByCity",
    method: "GET",
    params,
    headers,
  });
}
///introduce/introduceprotocol/info/list 获取经纪人协议
export function introduceprotocol (params, headers) {
  return partrequest({
    url: "introduce/introduceprotocol/info/list",
    method: "GET",
    params,
    headers,
  });
}
//领取优惠券
export function receiveCoupons (data, headers) {
  return anrequest({
    url: "/api-o/v1/partnerCoupon/receiveCoupons",
    method: "POST",
    data,
    headers,
  });
}
//添加浏览记录
export function addInterest (data, headers) {
  return anrequest({
    url: "/api-o/v1/broker/addInterest",
    method: "POST",
    data,
    headers,
  });
}
//添加分享记录
export function addShare (data, headers) {
  return anrequest({
    url: "/api-o/v1/broker/addShare",
    method: "POST",
    data,
    headers,
  });
}
//查询邀请记录信息
export function queryInvitationRecord (data, headers) {
  return request({
    url: "/api-o/v1/partnerCoupon/queryInvitationRecord",
    method: "POST",
    data,
    headers,
  });
}
//查询评论
export function queryCommentNew (data, headers) {
  return anrequest({
    url: "/api-c/v1/community/comment/selectCommentNew",
    method: "POST",
    data,
    headers,
  });
}
//查询任务是否完成
export function queryTaskDetail (data, headers) {
  return anrequest({
    url: "/api-u/v1/user/member/taskDetailInfo/" + data,
    method: "GET",
    headers
  })
}

//根据号查用户 /api-u/v1/user/info/getUserInfoByUserId/{userId} 
export function getUserInfoByUserId (data, headers) {
  return request({
    url: "/api-u/v1/user/info/getUserInfoByUserId/" + data.phone,
    method: "GET",
    data,
    headers,
  });
}

// /api-o/v1/broker//userLabelByUserId/{userId}  
//根据手机号查询用户身份标签
export function userLabelByUserId (data, headers) {
  return request({
    url: "/api-o/v1/broker/userLabelByUserId/" + data.mobile,
    method: "GET",
    data,
    headers,
  });
}
